import { TRACKER_MESSAGE_HISTORY_RECORD_STATE } from '@racemap/sdk/schema/trackers';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { Space, Tag } from 'antd';
import type { Immutable } from 'immer';
import { useStore } from '../../../store/reducers';
import type {
  ManagedTracker,
  ManagedTrackerMessages,
} from '../../../store/trackers/trackers_reducers';
import { type Column, SimpleTable } from '../../BasicComponents/SimpleTable';
import { StatusText } from './StatusText';
import { TrackerMessageDetails } from './TrackerMessageDetails';
import { TrackerMessageButtonsBody } from './TrackerMessageTableButtonsBody';
import { TrackerMessageTableButtonsHeader } from './TrackerMessageTableButtonsHeader';
import { getCurrentMessageStatusCode } from './TrackerMessagesTableHelper';

type Props = {
  tracker: Immutable<ManagedTracker>;
};
type TrackerMessages = Array<Immutable<ManagedTrackerMessages>>;

export function TrackerMessagesTable({ tracker }: Props): React.ReactElement {
  const { updateTrackerMessage } = useStore((s) => s.trackers.actions);

  const sortedMessages: TrackerMessages = [...tracker.messages].sort(
    (a, b) => new Date(b.plannedAt).getTime() - new Date(a.plannedAt).getTime(),
  );

  const columns: Array<Column<Immutable<ManagedTrackerMessages>>> = [
    {
      header: '#',
      dataKey: 'id',
      headerClassName: 'center',
      width: '35px',
      cellStyle: { justifyContent: 'center' },
      cellRenderer: (_c, _r, i) => <b>{i}</b>,
      key: 'index',
    },
    {
      dataKey: 'label',
      header: 'Message',
      key: 'label',
      cellStyle: { justifyContent: 'flex-start' },
      cellRenderer: (_c, r, _i) => (
        <Space>
          <b>{r.label}</b>
          <Tag color={RacemapColors.PaleBlue}>{r.transport}</Tag>
        </Space>
      ),
    },
    {
      header: 'Status',
      dataKey: 'id',
      key: 'status',
      cellStyle: { justifyContent: 'flex-start' },
      cellRenderer: (_c, r) => <StatusText message={r} />,
    },
    {
      header: (
        <TrackerMessageTableButtonsHeader sortedMessages={sortedMessages} trackerId={tracker.id} />
      ),
      key: 'action',
      dataKey: 'id',
      cellRenderer: (_c, r) => {
        return <TrackerMessageButtonsBody trackerMessage={r} trackerId={tracker.id} />;
      },
    },
  ];
  return (
    <SimpleTable
      columns={columns}
      data={sortedMessages}
      getRowStyle={(r) =>
        getCurrentMessageStatusCode(r) === TRACKER_MESSAGE_HISTORY_RECORD_STATE.REVOKED
          ? { color: '#bcbdbd' }
          : {}
      }
      subRowRenderer={(message) => (
        <TrackerMessageDetails
          message={message}
          onChange={(newMessage) => updateTrackerMessage(message.id, newMessage)}
        />
      )}
    />
  );
}
